import { render } from "./EmployeeApprovedServiceReports.vue?vue&type=template&id=61de5f42"
import script from "./EmployeeApprovedServiceReports.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedServiceReports.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__